import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e38e00fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-primary d-flex align-items-center",
  role: "alert"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "currentColor",
    class: "bi bi-exclamation-triangle-fill flex-shrink-0 me-2",
    viewBox: "0 0 16 16",
    role: "img",
    "aria-label": "Warning:"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " An example alert with an icon ")
], -1))
const _hoisted_4 = { class: "col-12 bg-light p-3" }
const _hoisted_5 = { class: "d-flex justify-content-between" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Order List", -1))
const _hoisted_7 = { class: "col-12 bg-light p-3" }
const _hoisted_8 = { class: "row height d-flex justify-content-center align-items-center" }
const _hoisted_9 = { class: "col-md-8" }
const _hoisted_10 = { class: "search" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1))
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "table table-striped table-sm" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Order No#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "PickUp Date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "City"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "User"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Driver"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Payment"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Combo"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "No"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1))
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "text-start" }
const _hoisted_21 = { class: "text-start" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "text-start" }
const _hoisted_24 = { class: "text-start" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "text-start" }
const _hoisted_27 = { class: "text-start" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "text-start" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "text-start" }
const _hoisted_32 = { class: "btn-group mr-2" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { colspan: "12" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Account Type", -1))
const _hoisted_37 = { class: "col-sm-3 text-end" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Business Name", -1))
const _hoisted_39 = { class: "col-sm-3 text-end" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package Total", -1))
const _hoisted_42 = { class: "col-sm-3 text-end" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Distance Cost", -1))
const _hoisted_44 = { class: "col-sm-3 text-end" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Total Distance", -1))
const _hoisted_47 = { class: "col-sm-3 text-end" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Pickup Address", -1))
const _hoisted_49 = { class: "col-sm-3 text-end" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Courier Note", -1))
const _hoisted_52 = { class: "col-sm-3 text-end" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Tax", -1))
const _hoisted_54 = { class: "col-sm-3 text-end" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Cancel Note", -1))
const _hoisted_57 = { class: "col-sm-3 text-end" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "is Paid", -1))
const _hoisted_59 = { class: "col-sm-3 text-end" }
const _hoisted_60 = {
  key: 0,
  class: "row"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Order Id", -1))
const _hoisted_62 = { class: "col-sm-3 text-end" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Order Number", -1))
const _hoisted_64 = { class: "col-sm-3 text-end" }
const _hoisted_65 = {
  key: 1,
  class: "row"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Pickup Distance ", -1))
const _hoisted_67 = { class: "col-sm-3 text-end" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Combine Delivery Distance ", -1))
const _hoisted_69 = { class: "col-sm-3 text-end" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Accepted Date ", -1))
const _hoisted_72 = { class: "col-sm-3 text-end" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Rider Arrived at PickUp ", -1))
const _hoisted_75 = { class: "col-sm-3 text-end" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Collected Date ", -1))
const _hoisted_79 = { class: "col-sm-3 text-end" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, " Order Delivered Date ", -1))
const _hoisted_82 = { class: "col-sm-3 text-end" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "row" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Created Date ", -1))
const _hoisted_86 = { class: "col-sm-3 text-end" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Updated Date", -1))
const _hoisted_88 = { class: "col-sm-3 text-end" }
const _hoisted_89 = { key: 2 }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Rider Detail", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_93 = { class: "row" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Name", -1))
const _hoisted_95 = { class: "col-sm-3 text-end" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Phone", -1))
const _hoisted_97 = { class: "col-sm-3 text-end" }
const _hoisted_98 = { class: "row" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Email", -1))
const _hoisted_100 = { class: "col-sm-3 text-end" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Rider Img", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "{{order.driver.rider_profile_img}}",
    width: "50"
  })
], -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Payment Detail", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_106 = { class: "row" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Payment Method", -1))
const _hoisted_108 = { class: "col-sm-3 text-end" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, null, -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-end" }, null, -1))
const _hoisted_111 = {
  key: 3,
  class: "row"
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Type", -1))
const _hoisted_113 = { class: "col-sm-3 text-end" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Card", -1))
const _hoisted_115 = { class: "col-sm-3 text-end" }
const _hoisted_116 = {
  key: 4,
  class: "row"
}
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Exp Date", -1))
const _hoisted_118 = { class: "col-sm-3 text-end" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Name ", -1))
const _hoisted_120 = { class: "col-sm-3 text-end" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Request Details", -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_124 = { class: "row" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Request ID", -1))
const _hoisted_126 = { class: "col-sm-3 text-end" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Total Cost", -1))
const _hoisted_128 = { class: "col-sm-3 text-end" }
const _hoisted_129 = { class: "row" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Total Distance ", -1))
const _hoisted_131 = { class: "col-sm-3 text-end" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Distance Cost ", -1))
const _hoisted_133 = { class: "col-sm-3 text-end" }
const _hoisted_134 = { class: "row" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package", -1))
const _hoisted_136 = { class: "col-sm-3 text-end" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Package Cost ", -1))
const _hoisted_138 = { class: "col-sm-3 text-end" }
const _hoisted_139 = { class: "row" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Customer Name", -1))
const _hoisted_141 = { class: "col-sm-3 text-end" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Customer Email ", -1))
const _hoisted_143 = { class: "col-sm-3 text-end" }
const _hoisted_144 = { class: "row" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Customer Phone", -1))
const _hoisted_146 = { class: "col-sm-3 text-end" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Customer Address ", -1))
const _hoisted_148 = { class: "col-sm-3 text-end" }
const _hoisted_149 = { class: "row" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Courier Note", -1))
const _hoisted_151 = { class: "col-sm-3 text-end" }
const _hoisted_152 = {
  key: 0,
  class: "col-sm-3 text-start fw-bold"
}
const _hoisted_153 = {
  key: 1,
  class: "col-sm-3 text-end"
}
const _hoisted_154 = {
  key: 0,
  class: "row"
}
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Collection Date", -1))
const _hoisted_156 = { class: "col-sm-3 text-end" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Cash Collection Amount", -1))
const _hoisted_158 = { class: "col-sm-3 text-end" }
const _hoisted_159 = { class: "row" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Request Item Status ", -1))
const _hoisted_161 = { class: "col-sm-3 text-end fw-bold" }
const _hoisted_162 = {
  key: 0,
  class: "col-sm-3 text-start fw-bold"
}
const _hoisted_163 = {
  key: 1,
  class: "col-sm-3 text-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("a", {
            href: "javascript:void(0)",
            id: "export-btn",
            class: "btn btn-sm btn-primary align-self-center",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.exportCSV && $setup.exportCSV(...args)))
          }, "Export")
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "Search with order Id or order number or total price",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.search) = $event))
              }, null, 512), [
                [_vModelText, $setup.search]
              ]),
              _createElementVNode("button", {
                id: "order-search-btn",
                class: "btn btn-primary",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.searchcall && $setup.searchcall(...args)))
              }, "Search"),
              _createElementVNode("button", {
                id: "order-clear-search-btn",
                class: "btn btn-primary clear",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.searchclear && $setup.searchclear(...args)))
              }, "Clear")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("table", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orders, (order) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: order.id
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_16, _toDisplayString(order.id), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(order.order_number), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(order.total_price), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString($options.dateTime(order.pickup_date)), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(order.city?.name), 1),
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("a", {
                        href: `/users/${order.user?.id}/view`
                      }, _toDisplayString(order.user?.full_name), 9, _hoisted_22)
                    ]),
                    _createElementVNode("td", _hoisted_23, _toDisplayString(order.orderstatus?.name), 1),
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("a", {
                        href: `/drivers/${order.driver?.id}/detail`
                      }, _toDisplayString(order.driver?.rider_name), 9, _hoisted_25)
                    ]),
                    _createElementVNode("td", _hoisted_26, _toDisplayString(order.paymentmethod?.name), 1),
                    _createElementVNode("td", _hoisted_27, [
                      (order.is_combine_delivery)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(order.combine_order_id), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_29, [
                      (order.combine_order_number)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(order.combine_order_number), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("a", {
                          href: "javascript:void(0)",
                          class: "btn btn-sm btn-primary me-2",
                          onClick: ($event: any) => ($setup.select(order.id))
                        }, " View", 8, _hoisted_33),
                        (order.orderstatus?.id==1 || order.orderstatus?.id==4 || order.orderstatus?.id==5 || order.orderstatus?.id==6 || order.orderstatus?.id==7 || order.orderstatus?.id==8 || order.orderstatus?.id==9 || order.orderstatus?.id==10)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/orders/${order.id}/edit`,
                              class: "btn btn-sm btn-secondary me-2 btn-edit"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Edit")
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true),
                        ( order.orderstatus?.id==8 || order.orderstatus?.id==9 || order.orderstatus?.id==10)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 1,
                              to: `/order/tracking/${order.id}/customer`,
                              target: "_blank",
                              class: "btn btn-sm btn-primary me-2 btn-tracking"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Tracking")
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_router_link, {
                          to: `/orders/${order.id}/log`,
                          class: "btn btn-sm btn-warning me-2 btn-log"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Log")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_34, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["overflow-hidden", $setup.selected=== order.id ? 'show': 'hide' ])
                      }, [
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, _toDisplayString(order.user?.account_type), 1),
                          _hoisted_38,
                          _createElementVNode("div", _hoisted_39, _toDisplayString(order.user?.bussiness_name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("div", _hoisted_42, _toDisplayString(order.total_package_price), 1),
                          _hoisted_43,
                          _createElementVNode("div", _hoisted_44, _toDisplayString(order.total_distance_price), 1)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createElementVNode("div", _hoisted_47, _toDisplayString(order.total_distance) + " " + _toDisplayString(order.distance_type), 1),
                          _hoisted_48,
                          _createElementVNode("div", _hoisted_49, _toDisplayString(order.pickup_address), 1)
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _hoisted_51,
                          _createElementVNode("div", _hoisted_52, _toDisplayString(order.courier_note), 1),
                          _hoisted_53,
                          _createElementVNode("div", _hoisted_54, _toDisplayString(order.tax), 1)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("div", _hoisted_57, _toDisplayString(order.cancel_note), 1),
                          _hoisted_58,
                          _createElementVNode("div", _hoisted_59, _toDisplayString(order.is_paid), 1)
                        ]),
                        (order.is_combine_delivery)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _hoisted_61,
                              _createElementVNode("div", _hoisted_62, _toDisplayString(order.combine_order_id), 1),
                              _hoisted_63,
                              _createElementVNode("div", _hoisted_64, _toDisplayString(order.combine_order_numer), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (order.is_combine_delivery)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              _hoisted_66,
                              _createElementVNode("div", _hoisted_67, _toDisplayString(order.combine_pickup_distance) + " " + _toDisplayString(order.distance_type), 1),
                              _hoisted_68,
                              _createElementVNode("div", _hoisted_69, _toDisplayString(order.combine_delivery_distance) + " " + _toDisplayString(order.distance_type), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_70, [
                          _hoisted_71,
                          _createElementVNode("div", _hoisted_72, [
                            (order.order_accepted_date)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString($options.dateTime(order.order_accepted_date)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_74,
                          _createElementVNode("div", _hoisted_75, [
                            (order.arrived_at_pickup_date)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString($options.dateTime(order.arrived_at_pickup_date)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_77, [
                          _hoisted_78,
                          _createElementVNode("div", _hoisted_79, [
                            (order.order_collected_date)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString($options.dateTime(order.order_collected_date)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_81,
                          _createElementVNode("div", _hoisted_82, [
                            (order.order_delivered_date)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString($options.dateTime(order.order_delivered_date)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_84, [
                          _hoisted_85,
                          _createElementVNode("div", _hoisted_86, _toDisplayString($options.dateTime(order.created_at)), 1),
                          _hoisted_87,
                          _createElementVNode("div", _hoisted_88, _toDisplayString($options.dateTime(order.updated_at)), 1)
                        ]),
                        (order.driver)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_89, [
                              _hoisted_90,
                              _hoisted_91,
                              _hoisted_92,
                              _createElementVNode("div", _hoisted_93, [
                                _hoisted_94,
                                _createElementVNode("div", _hoisted_95, _toDisplayString(order.driver.rider_name), 1),
                                _hoisted_96,
                                _createElementVNode("div", _hoisted_97, _toDisplayString(order.driver.rider_mobile_no), 1)
                              ]),
                              _createElementVNode("div", _hoisted_98, [
                                _hoisted_99,
                                _createElementVNode("div", _hoisted_100, _toDisplayString(order.driver.rider_email), 1),
                                _hoisted_101,
                                _hoisted_102
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_103,
                        _hoisted_104,
                        _hoisted_105,
                        _createElementVNode("div", _hoisted_106, [
                          _hoisted_107,
                          _createElementVNode("div", _hoisted_108, _toDisplayString(order.paymentmethod.name), 1),
                          _hoisted_109,
                          _hoisted_110
                        ]),
                        (order.brand)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                              _hoisted_112,
                              _createElementVNode("div", _hoisted_113, _toDisplayString(order.brand), 1),
                              _hoisted_114,
                              _createElementVNode("div", _hoisted_115, " xxxxxxxxxxxx" + _toDisplayString(order.last4), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (order.exp_year)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                              _hoisted_117,
                              _createElementVNode("div", _hoisted_118, _toDisplayString(order.exp_month) + "/" + _toDisplayString(order.exp_year), 1),
                              _hoisted_119,
                              _createElementVNode("div", _hoisted_120, _toDisplayString(order.card_name), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.order_items, (orderitem) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: orderitem.id
                          }, [
                            _hoisted_121,
                            _hoisted_122,
                            _hoisted_123,
                            _createElementVNode("div", _hoisted_124, [
                              _hoisted_125,
                              _createElementVNode("div", _hoisted_126, _toDisplayString(orderitem.id), 1),
                              _hoisted_127,
                              _createElementVNode("div", _hoisted_128, _toDisplayString(orderitem.price), 1)
                            ]),
                            _createElementVNode("div", _hoisted_129, [
                              _hoisted_130,
                              _createElementVNode("div", _hoisted_131, _toDisplayString(orderitem.distance) + " " + _toDisplayString(orderitem.distance_type), 1),
                              _hoisted_132,
                              _createElementVNode("div", _hoisted_133, _toDisplayString(orderitem.distance_price), 1)
                            ]),
                            _createElementVNode("div", _hoisted_134, [
                              _hoisted_135,
                              _createElementVNode("div", _hoisted_136, _toDisplayString(orderitem.package?.name), 1),
                              _hoisted_137,
                              _createElementVNode("div", _hoisted_138, _toDisplayString(orderitem.package_price), 1)
                            ]),
                            _createElementVNode("div", _hoisted_139, [
                              _hoisted_140,
                              _createElementVNode("div", _hoisted_141, _toDisplayString(orderitem.customer_name), 1),
                              _hoisted_142,
                              _createElementVNode("div", _hoisted_143, _toDisplayString(orderitem.customer_email), 1)
                            ]),
                            _createElementVNode("div", _hoisted_144, [
                              _hoisted_145,
                              _createElementVNode("div", _hoisted_146, _toDisplayString(orderitem.customer_phone), 1),
                              _hoisted_147,
                              _createElementVNode("div", _hoisted_148, _toDisplayString(orderitem.customer_address), 1)
                            ]),
                            _createElementVNode("div", _hoisted_149, [
                              _hoisted_150,
                              _createElementVNode("div", _hoisted_151, _toDisplayString(orderitem.courier_note), 1),
                              (orderitem.delivered_date)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_152, "Delivered Date"))
                                : _createCommentVNode("", true),
                              (orderitem.delivered_date)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_153, _toDisplayString($options.dateTime(orderitem.delivered_date)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (orderitem.is_cash_collection)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                  _hoisted_155,
                                  _createElementVNode("div", _hoisted_156, _toDisplayString($options.dateTime(orderitem.collection_date)), 1),
                                  _hoisted_157,
                                  _createElementVNode("div", _hoisted_158, _toDisplayString(orderitem.cash_collection_amount), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_159, [
                              _hoisted_160,
                              _createElementVNode("div", _hoisted_161, _toDisplayString(orderitem.itemstatus?.name), 1),
                              (!orderitem.delivered_date)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_162, "Action "))
                                : _createCommentVNode("", true),
                              (!orderitem.delivered_date)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                    _createVNode(_component_router_link, {
                                      to: `/orderitems/${orderitem.id}/edit`,
                                      class: "btn btn-sm btn-secondary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Edit")
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 64))
                        }), 128))
                      ], 2)
                    ])
                  ])
                ], 64))
              }), 128))
            ])
          ])
        ])
      ]),
      _createVNode(_component_v_pagination, {
        modelValue: _ctx.page,
        "onUpdate:modelValue": [
          _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page) = $event)),
          _cache[5] || (_cache[5] = ($event: any) => ($setup.load($event)))
        ],
        pages: $setup.lastPage,
        "range-size": 1,
        "active-color": "#DCEDFF"
      }, null, 8, ["modelValue", "pages"])
    ])
  ]))
}